import { SearchType } from '@search-bar/entities/search-type';
import { AssetPopularDestinations } from '@asset-popular-destinations';
import { PlaceType } from '@shared/base-search-bar/entities/place-type';

interface PopularDestinationAssetinterface {
  FLIGHTS: string[];
  HOTELS: string[];
  BYHOURS: string[];
  AUTOS: string[];
  BUSES: string[];
  PACKAGES: string[];
  TOUR_AND_ACTIVITIES: string[];
  BASE_IMAGE: string;
}

export function getProductPopularDestinations(searchType: SearchType, placeType: PlaceType, departurePlace: string): string[] {
  const popularsByCountry: PopularDestinationAssetinterface = AssetPopularDestinations;
  let result;
  switch (searchType) {
    case SearchType.FLIGHT_RESULTS:
    case SearchType.FLIGHT_USER_HISTORY:
    case SearchType.HOME_FLIGHT:
    case SearchType.ALERT:
      result = departurePlace && placeType === PlaceType.ARRIVAL ?
        popularsByCountry.FLIGHTS.filter(code => filterByCode(code, departurePlace)) : popularsByCountry.FLIGHTS;
      break;
    case SearchType.HOME_HOTELS:
    case SearchType.HOTELS_RESULTS:
      result = popularsByCountry.HOTELS;
      break;
    case SearchType.HOME_BYHOURS:
    case SearchType.BYHOURS_RESULTS:
      result = popularsByCountry.BYHOURS;
      break;
    case SearchType.HOME_AUTOS:
    case SearchType.AUTOS_DETAIL:
    case SearchType.AUTOS_RESULTS:
      result = departurePlace && placeType === PlaceType.ARRIVAL ?
        popularsByCountry.AUTOS.filter(code => filterByCode(code, departurePlace)) : popularsByCountry.AUTOS;
      break;
    case SearchType.HOME_BUSES:
    case SearchType.BUSES_RESULTS:
      result = departurePlace && placeType === PlaceType.ARRIVAL ?
        popularsByCountry.BUSES.filter(code => filterByCode(code, departurePlace)) : popularsByCountry.BUSES;
      break;
    case SearchType.PACKAGES_HOME:
    case SearchType.PACKAGES_RESULT:
      result = departurePlace && placeType === PlaceType.ARRIVAL ?
        popularsByCountry.PACKAGES.filter(code => filterByCode(code, departurePlace)) : popularsByCountry.PACKAGES;
      break;
    case SearchType.TOUR_AND_ACTIVITIES:
      result = popularsByCountry.TOUR_AND_ACTIVITIES;
      break;
    default:
      result = [];
  }
  return result;
}

function filterByCode(code: string, placeCode: string): boolean {
  return placeCode !== code;
}
